import React from "react";
import { Link } from "react-router";

export default function raytolfas_toastify() {
    return (
        <div className="container">
            <div className="home-container">
                <h1 className="home-text">RAYTOLFAS - @RAYTOLFAS/TOASTIFY</h1>
            </div>

            <div className="content-container">
                <h1>ПРОВЕРИТЬ РАБОТУ ФРЕЙМВОРКА</h1>
                <Link to="https://toastify-test.raytolfas.com" className="Link-button">Проверить</Link>
            </div>

            <div className="content-container">
                <h1>Документация по фреймворку</h1>
                <button onClick={() => window.location.href = "https://docs.raytolfas.com"}>Посмотреть</button>
            </div>
        </div>
    );
}
